import { FCX } from "@datassential/platform-ui-lib";
import { AsideButton } from "./AsideButtons";
import { RiFilePpt2Fill, RiFileCheckFill } from "react-icons/ri";
import { LiaSpinnerSolid } from "react-icons/lia";
import { FC, useCallback, useMemo, useState } from "react";
import cn from "classnames";
import { useExport } from "@api/useExport";

const PptExportButton: FCX<{
    url: string;
    payload?: any;
}> = ({
    url,
    payload,
    className,
    style,
    testId,
}) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const { isLoading, get } = useExport(url, payload);

    const onClick = useCallback(
        () => {
            get().then(() => {
                setIsSuccess(true);

                setTimeout(() => {
                    setIsSuccess(false);
                }, 4000);
            });
        },
        [get]
    );

    const Icon: FC<{ className?: string}> = useCallback(
        ({ className, ...rest }) => {
            const props = {
                className: cn(
                    "appears",
                    isLoading && "fade-spin",
                    className,
                ),
                ...rest,
            };
            if (isLoading) {
                return <LiaSpinnerSolid {...props}/>;
            }
            if (isSuccess) {
                return <RiFileCheckFill {...props}/>;
            }
            return <RiFilePpt2Fill {...props}/>;
        },
        [isSuccess, isLoading]
    );

    const title = useMemo(
        () => {
            if (isLoading) return "Please wait";
            if (isSuccess) return "done!";
            return "PPT";
        },
        [isSuccess, isLoading]
    );

    return (
        <AsideButton
            title={title}
            icon={Icon}
            onClick={(isLoading || isSuccess) ? undefined : onClick}
            className={className}
            testId={testId}
            style={style}
            isDisabled={isSuccess}
        />
    );
}

export default PptExportButton;